import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Import Images
import aboutThumb1 from '../../images/about/pic-1.jpg';
import aboutThumb2 from '../../images/about/pic-2.jpg';
import aboutThumb3 from '../../images/about/pic-4.png';
import icon1 from '../../images/shap/icon1.png';
import icon2 from '../../images/shap/icon2.png';
import icon3 from '../../images/shap/icon3.png';
import icon4 from '../../images/shap/icon4.png';

const AboutSection = () => {
    const location = useLocation(); // Get the current URL path

    return (
        <>
            <section className="section-sp1 about-area">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-30">
                            <div className="about-thumb-area">
                                <ul>
                                    <li><img className="about-thumb1" src={aboutThumb1} alt="" /></li>
                                    <li><img className="about-thumb2" src={aboutThumb2} alt="" /></li>
                                    <li><img className="about-thumb3" src={aboutThumb3} alt="" /></li>
                                    <li>
                                        <div className="exp-bx" style={{ fontSize: '5rem', textAlign: 'center', lineHeight: '1' }}>
                                            30+
                                            <span style={{ display: 'block', fontSize: '1.3rem', lineHeight: '1', marginTop: '10px' }}>
                                                Years Combined
                                            </span>
                                            <span style={{ display: 'block', fontSize: '1.3rem', lineHeight: '1', marginTop: '5px' }}>
                                                Experience
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-30">
                            <div className="heading-bx">
                                <h6 className="title-ext text-secondary">About Us</h6>
                                <h2 className="title">Compassionate Care, Eco-Conscious Approach.</h2>
                                <p>At Family Eco Dental, inspired by Dr. Figueredo's visionary approach, we aim for more than the average dental practice. Our mission is to integrate high-tech, eco-friendly innovations into a modernized office environment that enhances comfort and peace of mind for every patient. Through compassionate care and comprehensive education, we empower our community to achieve and maintain optimal oral health for life. Together, we are committed to making a meaningful impact, ensuring that every individual who walks through our doors receives exceptional care and support on their dental journey.</p>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
                                    <div className="feature-container feature-bx1 feature1">
                                        <div className="icon-md">
                                            <span className="icon-cell">
                                                <img src={icon1} alt="" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="ttr-title">Emergency Help</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
                                    <div className="feature-container feature-bx1 feature2">
                                        <div className="icon-md">
                                            <span className="icon-cell">
                                                <img src={icon2} alt="" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="ttr-title">Qualified Doctors</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
                                    <div className="feature-container feature-bx1 feature3">
                                        <div className="icon-md">
                                            <span className="icon-cell">
                                                <img src={icon3} alt="" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="ttr-title">Relaxing Environment</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
                                    <div className="feature-container feature-bx1 feature4">
                                        <div className="icon-md">
                                            <span className="icon-cell">
                                                <img src={icon4} alt="" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="ttr-title">Effective Treatment</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Render the "Read More" button only if not on the "About Us" page */}
                            {location.pathname !== '/about-us' && (
                                <Link to="/about-us" className="btn btn-primary shadow">Read More</Link>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AboutSection;